import React, { useEffect } from 'react'

function OtherInfoContributions({ otherContributionsInfo, setOtherContributionsInfo, departmentalServiceCount, setDepartmentalServiceCount, facultyServiceCount, 
    setFacultyServiceCount, universityServiceCount, setUniversityServiceCount, externalUniversityServiceCount, setExternalUniversityServiceCount, userSignature, setUserSignature, signatureElement, setUserUploadedSignature, userUploadedSignature }) {

    const handleChange = (e) =>{
        setOtherContributionsInfo({
            ...otherContributionsInfo, [e.target.name] : e.target.value
        });
    }

    const handleImageChange = (e) =>{
        setUserSignature(e.target.files[0]);
        setOtherContributionsInfo({
            ...otherContributionsInfo, [e.target.name] : e.target.value
        });
    }
    useEffect(() => {
        console.log(signatureElement.current);
        signatureElement.current.files = userUploadedSignature;
      }, [])
    // const [textCounter, setTextCounter] = useState(0);

  return (
    <div className='flex flex-col box-border gap-4'>
        <div className=''>
            <h1 className='text-custom-blue font-bold text-2xl lg:text-3xl'>Other Relevant Information and Contributions to Knowledge</h1>
        </div>
        <div className='flex flex-col box-border gap-4'>
            <p className='text-custom-brown font-semibold text-sm border-b border-custom-brown sm:text-base md:text-lg'>Other relevant Information</p>
            <div className='flex flex-col gap-4 justify-between'>
                <div className='flex flex-col box-border gap-4'>
                    <p className='text-custom-brown text-sm font-semibold sm:text-base'>(A) Services within the Department</p>
                    {
                        Array.apply(null, {length: departmentalServiceCount}).map((e, i)=>(
                        <div key={i} className='flex flex-col gap-1 w-full box-border'>
                            <label className='text-custom-brown text-base' htmlFor={`departmentalServices${i+1}`}>Services to the Department {i+1}</label>
                            <input className='border box-border border-custom-brown hover:border-custom-blue outline-none rounded text-base p-2 bg-transparent' type='text' name={`departmentalServices${i+1}`} id={`departmentalServices${i+1}`} onChange={handleChange} value={otherContributionsInfo[`departmentalServices${i+1}`]} />
                        </div>
                    ))}
                    <div className='flex gap-5 justify-end'>
                        {
                            departmentalServiceCount>1 ? 
                            <button type='button' onClick={()=>{setDepartmentalServiceCount(departmentalServiceCount-1)}} className="py-3 px-4 w-fit font-medium text-base rounded-md bg-[#E02424] text-white active:bg-custom-brown md:hover:bg-custom-brown cursor-pointer"> 
                                Remove Last
                            </button> : null
                        }
                        <button type='button' className='p-2.5 text-white font-medium text-sm rounded-md hover:bg-custom-blue bg-custom-dark-blue hover:text-slate-400 cursor-pointer' onClick={()=>setDepartmentalServiceCount(departmentalServiceCount+1)}>
                                Add More
                        </button>
                    </div>
                </div>
                <div className='flex flex-col box-border gap-4'>
                    <p className='text-custom-brown text-sm font-semibold sm:text-base'>(B) Services within the Faculty</p>
                    {
                        Array.apply(null, {length: facultyServiceCount}).map((e, i)=>(
                        <div key={i} className='flex flex-col gap-1 w-full box-border'>
                            <label className='text-custom-brown text-base' htmlFor={`facultyServices${i+1}`}>Service to the Faculty {i+1}</label>
                            <input className='border box-border border-custom-brown hover:border-custom-blue outline-none rounded text-base p-2 bg-transparent' type='text' name={`facultyServices${i+1}`} id={`facultyServices${i+1}`} onChange={handleChange} value={otherContributionsInfo[`facultyServices${i+1}`]} />
                        </div>
                    ))}
                    <div className='flex gap-5 justify-end'>
                        {
                            facultyServiceCount>1 ? 
                            <button type='button' onClick={()=>{setFacultyServiceCount(facultyServiceCount-1)}} className="py-3 px-4 w-fit font-medium text-base rounded-md bg-[#E02424] text-white active:bg-custom-brown md:hover:bg-custom-brown cursor-pointer"> 
                                Remove Last
                            </button> : null
                        }
                        <button type='button' className='p-2.5 text-white font-medium text-sm rounded-md hover:bg-custom-blue bg-custom-dark-blue hover:text-slate-400 cursor-pointer' onClick={()=>setFacultyServiceCount(facultyServiceCount+1)}>
                            Add More
                        </button>
                    </div>
                </div>
                <div className='flex flex-col box-border gap-4'>
                    <p className='text-custom-brown text-sm font-semibold sm:text-base'>(C) Services within the Univeristy</p>
                    {
                        Array.apply(null, {length: universityServiceCount}).map((e, i)=>(
                        <div key={i} className='flex flex-col gap-1 w-full box-border'>
                            <label className='text-custom-brown text-base' htmlFor={`universityService${i+1}`}>Services to the University {i+1}</label>
                            <input className='border box-border border-custom-brown hover:border-custom-blue outline-none rounded text-base p-2 bg-transparent' type='text' name={`universityService${i+1}`} id={`universityService${i+1}`} onChange={handleChange} value={otherContributionsInfo[`universityService${i+1}`]} />
                        </div>
                    ))}
                    <div className='flex gap-5 justify-end'>
                        {
                            universityServiceCount>1 ? 
                            <button type='button' onClick={()=>{setUniversityServiceCount(universityServiceCount-1)}} className="py-3 px-4 w-fit font-medium text-base rounded-md bg-[#E02424] text-white active:bg-custom-brown md:hover:bg-custom-brown cursor-pointer"> 
                                Remove Last
                            </button> : null
                        }
                        <button type='button' className='p-2.5 text-white font-medium text-sm rounded-md hover:bg-custom-blue bg-custom-dark-blue hover:text-slate-400 cursor-pointer' onClick={()=>setUniversityServiceCount(universityServiceCount+1)}>
                                Add More
                        </button>
                    </div>
                </div>
                <div className='flex flex-col box-border gap-4'>
                    <p className='text-custom-brown text-sm font-semibold sm:text-base'>(D) Services outside the Univeristy</p>
                    {
                        Array.apply(null, {length: externalUniversityServiceCount}).map((e, i)=>(
                        <div key={i} className='flex flex-col gap-1 w-full box-border'>
                            <label className='text-custom-brown text-base' htmlFor={`externalUniversityService${i+1}`}>Services outside the Univeristy {i+1}</label>
                            <input className='border box-border border-custom-brown hover:border-custom-blue outline-none rounded text-base p-2 bg-transparent' type='text' name={`externalUniversityService${i+1}`} id={`externalUniversityService${i+1}`} onChange={handleChange} value={otherContributionsInfo[`externalUniversityService${i+1}`]} />
                        </div>
                    ))}
                    <div className='flex gap-5 justify-end'>
                        {
                            externalUniversityServiceCount>1 ? 
                            <button type='button' onClick={()=>{setExternalUniversityServiceCount(externalUniversityServiceCount-1)}} className="py-3 px-4 w-fit font-medium text-base rounded-md bg-[#E02424] text-white active:bg-custom-brown md:hover:bg-custom-brown cursor-pointer"> 
                                Remove Last
                            </button> : null
                        }
                        <button type='button' className='p-2.5 text-white font-medium text-sm rounded-md hover:bg-custom-blue bg-custom-dark-blue hover:text-slate-400 cursor-pointer' onClick={()=>setExternalUniversityServiceCount(externalUniversityServiceCount+1)}>
                                Add More
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <p className='text-custom-brown font-semibold text-sm border-b border-custom-brown sm:text-base md:text-lg'>Contribution to Knowledge</p>
        <div className='flex flex-col gap-1 box-border'>
            <p className='text-custom-brown text-base'>Write a short but concrete description of your contribution to existing knowledge in area of specialization arising from extensive and innovative reseach</p>
            <textarea maxLength={200} className='text-base p-4 rounded-md outline-none border border-custom-brown hover:border-custom-blue' placeholder='This is to be written in prose form and with points/ ideas seperated using paragraphs.' 
            rows='14'  required name='knowledge_contribution' onChange={handleChange} value={otherContributionsInfo.knowledge_contribution}>
            </textarea>
        </div>
        <div className='flex flex-col gap-1 w-full box-border'>
            <label className='text-custom-brown text-base' htmlFor="signature">Signature</label>
            <input className='border box-border border-custom-brown hover:border-custom-blue outline-none rounded text-base p-2 bg-transparent' type='file' name="signature" id="signature" accept="image/*" ref={signatureElement} multiple={false} onChange={handleImageChange} value={otherContributionsInfo.signature} required/>
        </div>
        <div className='flex flex-col gap-1 w-full box-border'>
            <label className='text-custom-brown text-base' htmlFor="subDate">Date</label>
            <input className='border box-border border-custom-brown hover:border-custom-blue outline-none rounded text-base p-2 bg-transparent' type='date' name="subDate" id="subDate" onChange={handleChange} value={otherContributionsInfo.subDate} required/>
        </div>
    </div>
  )
}

export default OtherInfoContributions